import { Box, Button, Grid } from "@material-ui/core";
import { CardInfoConfirmarEntrega } from "../../../../../components/cards/card-info-confirmar-entrega/card-info-confirmar-entrega";
import { useSessaoAtual, useToastSaurus } from "../../../../../../services/app";
import { ConfirmarEntregaModel } from "../../../../../../model/app/forms/confirmar-entrega/confirmar-entrega-model";
import { useHistory, useLocation } from "react-router-dom";
import { useCallback } from "react";
import { EnumAssinatura } from "../../../../../../model/enums/enum-assinatura";
import { CircularLoading } from "../../../../../components";
import { usePutConfirmarRecebimento } from "../../../../../../data/api/gestao/processo-produto-setor/put-confirmar-recebimento";
import { ConfirmarRecebimentoModel } from "../../../../../../model/api/processo-produto-setor/confirmar-recebimento";
import { isEmpty } from "lodash";
import { useThemeQueries } from "../../../../../theme";
import { VoltarIcon } from "../../../../../components/icons";
import { ConfirmarIcon } from "../../../../../components/icons/confirmar-icon";
import { useEmpresaAtual } from "../../../../../../services/app/use-cases/empresa-atual";
import { EnumEmpresaConfig } from "../../../../../../model/enums/enum-empresa-config";

export const ConfirmarEntregaData = () => {

    const history = useHistory();
    const { showToast } = useToastSaurus();
    const { isMobile } = useThemeQueries();
    const { getEmpresaSelecionada, carregando: carregandoSessaoAtual } = useSessaoAtual();
    const { putConfirmarRecebimento, carregando: carregandoAlterarProcesso } = usePutConfirmarRecebimento();
    const { getConfigByCod } = useEmpresaAtual()

    const location = useLocation();
    const state = location.state as { processo: ConfirmarEntregaModel };
    const model = state.processo

    const carregando = carregandoSessaoAtual || carregandoAlterarProcesso;

    const putConfirmarRecebimentoWrapper = useCallback(async () => {
        const processos = new ConfirmarRecebimentoModel();

        processos.ids = model.processosProdutosIds;
        processos.imagemDados = ''

        const proximoProcesso = model.processoAtual + 1;
        const res = await putConfirmarRecebimento(getEmpresaSelecionada()?.Id!, proximoProcesso, processos);

        if (res.erro)
            throw res.erro

        return showToast('success', 'Pedido foi entregue com sucesso.')
    }, [model.processosProdutosIds, model.processoAtual, putConfirmarRecebimento, getEmpresaSelecionada, showToast])

    const configuracaoMesaEComanda = useCallback(async () => {
        if (!isEmpty(model.codigoComanda)) {
            history.push({
                pathname: '/ler-comanda',
                state
            })
            return
        }

        history.push({
            pathname: '/assinatura',
            state
        })
    }, [history, model.codigoComanda, state])

    const confirmarEntrega = useCallback(async () => {
        try {
            const assinatura = getConfigByCod(EnumEmpresaConfig.ConfirmacaoClienteMesa)
            if (Number(assinatura) === EnumAssinatura.PermiteAssinatura)
                return configuracaoMesaEComanda();

            await putConfirmarRecebimentoWrapper();
            return history.push('/')
        } catch (err: any) {
            showToast('error', err.message);
        }
    }, [configuracaoMesaEComanda, getConfigByCod, history, putConfirmarRecebimentoWrapper, showToast])

    return (
        <>
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <Grid container style={{
                padding: '16px',
                display: 'flex',
                justifyContent: 'center',
                height: '100%'
            }}>
                <Grid item xs={12} style={{
                    maxWidth: '600px',
                    height: '100%',
                    display: 'flex',
                }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            gap: '16px',
                            height: '100%'
                        }}>
                            <Box height={isMobile ? 0 : undefined} flex={isMobile ? 1 : undefined}>
                                <CardInfoConfirmarEntrega
                                    model={model}
                                />
                            </Box>
                            <Grid container spacing={2}>
                                {!isMobile && (
                                    <Grid item xs={6}>
                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            color="primary"
                                            size="large"
                                            startIcon={<VoltarIcon tipo="BUTTON_LOGOUT" />}
                                            onClick={() => history.push('/pedidos-para-entrega')}
                                        >
                                            <Box fontWeight={700}>
                                                Voltar
                                            </Box>
                                        </Button>
                                    </Grid>
                                )}
                                <Grid item xs={isMobile ? 12 : 6}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        fullWidth
                                        startIcon={<ConfirmarIcon tipo="BUTTON_PRIMARY" />}
                                        onClick={confirmarEntrega}
                                    >
                                        <Box fontWeight={700}>
                                            Confirmar Entrega
                                        </Box>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </>
    )
}